<template>

    <Toast />

    <MenuUserModuleMain v-if="(this.userStore.user.roles.includes('ROLE_USER', 0))" />
    <MenuSiModuleAffiliate v-else-if="(this.userStore.user.roles.includes('ROLE_ISOWEB', 0))" />
    <MenuMain v-else />

    <MenuSiProfile />
    <HeadingProfile />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Overview</h3>

                    <div class="field">
                        <label for="companyId">Company ID</label>
                        <InputText id="companyId" type="text" :disabled="true" v-model.trim="profile.companyId" />
                    </div>

                    <div class="field">
                        <label for="id">User ID</label>
                        <InputText id="id" type="text" :disabled="true" v-model.trim="profile.id" />
                    </div>

                    <div class="field">
                        <label for="username">Username</label>
                        <InputText id="username" :disabled="false" v-model.trim="profile.username" required="true" />
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" :disabled="false" v-model.trim="profile.email" required="true" />
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile</label>
                        <InputText id="mobile" :disabled="false" v-model.trim="profile.mobile" required="true" />
                    </div>

                    <div class="field">
                        <label for="firstName">First Name</label>
                        <InputText id="firstName" :disabled="false" v-model.trim="profile.firstName" required="true" />
                    </div>

                    <div class="field">
                        <label for="lastName">Last Name</label>
                        <InputText id="lastName" :disabled="false" v-model.trim="profile.lastName" required="true" />
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="processUpdateUser"></Button>

                </div>
            </div>
        </div>
    </div>

    <SiFooter />

</template>

<script>
import HeadingProfile from "@/components/heading/common/HeadingProfile.vue";
import MenuSiProfile from "@/components/menu/simodule/MenuSiProfile.vue";
import { useUserStore } from "@/stores/UserStore";
import UserService from "@/service/UserService";
import ClientService from "@/service/ClientService";
import MenuMain from "@/components/menu/common/MenuMain.vue";
import MenuUserModuleMain from "@/components/menu/usermodule/MenuUserModuleMain.vue";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";

export default {
    components: {
        SiFooter,
        MenuUserModuleMain,
        MenuMain,
        MenuSiProfile,
        HeadingProfile
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[AppointmentsNew][mounted] Data = ", userData);
            console.log("[AppointmentsNew][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }
    },
    data() {

        return {
            profile: {},
            client: {},
            submitted: false
        }
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        async processUpdateUser() {
            this.submitted = true;

            try {
                var newUserDto = {
                    id: this.userStore.user.id,
                    username: this.profile.username,
                    email: this.profile.email,
                    mobile: this.profile.mobile,
                    firstName: this.profile.firstName,
                    lastName: this.profile.lastName,
                    roles: this.profile.roles,
                };

                const response = await UserService.updateUser(this.userStore.user.id, newUserDto);
                console.log('[PhoneCalls][updatePhoneCall] Response = ', response);

                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;

                const [clientData] = await Promise.all([
                    ClientService.getClientForUser(this.userStore.user.id),
                ]);

                this.client = clientData.data;
                console.log("[AppointmentsNew][mounted] clientData.data = ", clientData.data);


                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Updated user details',
                    life: 3000
                });
            } catch (e) {
                console.error('[PhoneCalls][updatePhoneCall] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update user details. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            this.submitted = false;
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.assistant-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.assistant-badge {
    &.status-N {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-D {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-H {
        background: #ECCFFF;
        color: #694382;
    }

}
</style>
